module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dataTime":"Data Update Time: ","loadDataFailed":"Failed while loading data."},"ja":{"dataTime":"データ更新日：","loadDataFailed":"データの読み込みに失敗しました。"},"zh-Hant":{"dataTime":"資料更新日期：","loadDataFailed":"資料讀取失敗。"},"zh-Hans":{"dataTime":"数据更新日期：","loadDataFailed":"数据加载失败。"}}')
  delete Component.options._Ctor
}
